export default __webpack_public_path__ + "static/media/May2013.ab8c2623.png";